export const LOGO_TEXT = 'bank logo alt text'
export const LOGO_ALT_TEXT = 'This is the bank logo'
export const OFFSET_DAY = 24 * 60 * 60 * 1000
export const OFFSET_90_DAYS = OFFSET_DAY * 90
export const OFFSET_365_DAYS = OFFSET_DAY * 365 //FIXME: Can be a problem with a leap year
export const OFFSET_30_DAYS = OFFSET_DAY * 30
